import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeftIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'

import { requireAdmin } from '@/auth/guards'
import { MetaSettings } from '@/components/prospecting/meta-settings'
import { oneOf, readSearch, text } from '@/lib/search-params'

const SHAPE = {
  /** Le retour de Facebook Login. */
  meta: oneOf(['connected', 'error'] as const),
  reason: text(),
}

/**
 * Paramètres › Intégrations › Meta (lot 43, 1.86.0) : une page à part, parce
 * que l'app Meta, la connexion, les Pages et l'état demandent de la place. Le
 * retour de Facebook Login y revient (`?meta=connected|error`).
 */
export const Route = createFileRoute('/_app/settings/integrations_/meta')({
  beforeLoad: requireAdmin,
  validateSearch: (search: Record<string, unknown>) => readSearch(SHAPE, search),
  component: MetaSettingsPage,
})

function MetaSettingsPage() {
  const { meta, reason } = Route.useSearch()
  const navigate = Route.useNavigate()
  // Le retour se lit une fois, puis l'adresse redevient propre.
  const [returned] = useState(() => (meta ? { ok: meta === 'connected', reason } : undefined))
  useEffect(() => {
    if (!meta) return
    if (meta === 'connected')
      toast.success('Meta est connecté : choisissez les Pages et les comptes.')
    void navigate({ search: {}, replace: true })
  }, [meta, navigate])

  return (
    <div className="space-y-4">
      <Link
        to="/settings/integrations"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeftIcon className="size-4" aria-hidden="true" />
        Intégrations
      </Link>
      <h2 className="font-semibold tracking-tight">Meta — Facebook et Instagram</h2>
      <MetaSettings returned={returned} />
    </div>
  )
}
